import { createListenerMiddleware, type Dispatch } from "@reduxjs/toolkit";

import { updateVersionsAction } from "../../reducer/index.ts";
import { flushAction, type NautilusStateAction } from "../nautilusActions.ts";
import type { NautilusDesignerState } from "../nautilusState.ts";
import { isNodeAction } from "./shared.ts";

export const revisionCaptureListener = createListenerMiddleware<NautilusDesignerState, Dispatch<NautilusStateAction>>();

const MAX_EXPECTED_USER_ACTIONS = 20;

revisionCaptureListener.startListening({
  predicate: isNodeAction,
  effect: async (_action, { getState, dispatch, delay }) => {
    // Wait for the next tick to ensure the state is updated
    await delay(0);

    if (getState().pendingRevisionActions.length > 0) {
      const actions = getState().pendingRevisionActions;
      if (actions.length > MAX_EXPECTED_USER_ACTIONS && !actions.find(updateVersionsAction.match)) {
        console.warn(`High number of actions in one revision: ${actions.length}. Make sure this is not a bug in code.`);
      }
      dispatch(flushAction());
    }
  },
});
